import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { concatMap, from, map } from 'rxjs';
import { ServiciosService } from 'src/app/services/inventario/servicios.service';
import { DoctoresService } from 'src/app/services/personas/doctores.service';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgZone } from '@angular/core';


@Component({
    selector: 'app-subir-corporales',
    templateUrl: './subir-corporales.component.html',
    styleUrls: ['./subir-corporales.component.scss'],
    standalone: false
})
export class SubirCorporalesComponent implements OnInit {

 
  public nombrePaciente:string = "";
  public informeHtml: string = '';
  public nombreDoctor: string = "";
  detalleOrden: any[] = [];
  public metodosPagos:string = "Efectivo";
  public talonarioDocotor:string = "";
  detalleOrdenNew: any[] = [];  
  public idOrden: string = "";
  public spinnerBoolean: boolean = false;
  public cargando: string = "Obteniendo información por favor espere....";
  public txtOrdenFisica: string = "";
  public numeroOrden: string = ""
   //ngx-dropzone
	 private baseSistema: string = environment.systemLegacyUrl;
   public isRecording = false;
public audioUrl: string = '';
public audioFile: File | null = null;
public audioMime: string = '';

private mediaRecorder: MediaRecorder | null = null;
private audioChunks: BlobPart[] = [];
private audioStream: MediaStream | null = null;
public safeAudioUrl: SafeUrl | null = null;
private recognition: any;
public dictando = false;
public textoTemporal = '';

   constructor(

    public route: ActivatedRoute,
    public router: Router,
    private ordenesService: OrdenesService,
    private serviciosService: ServiciosService,
    private doctoresService: DoctoresService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
      private zone: NgZone,

  ) { }

  ngOnInit(): void {

    var idOrden = this.route.snapshot.paramMap.get('id')!.toString().substring(100,this.route.snapshot.paramMap.get('id')!.toString().length-100);
    this.idOrden = idOrden;
    this.spinnerBoolean = true;
    /* -------------------------------------------------------------------------- */
    /*                          OBTENER DATOS DE LA ORDEN                         */
    /* -------------------------------------------------------------------------- */
    this.ordenesService.mostrarOrdenesNormal(localStorage.getItem('token'),"normal","COD_ORD", idOrden).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));
      this.nombrePaciente = content[0].NOM_CLI;
      this.nombreDoctor = content[0].NOM_DOC;
    
      this.numeroOrden = content[0].NUM_ORD
        /* -------------------------------------------------------------------------- */
      /*                              DATOS DEL DOCTOR                              */
      /* -------------------------------------------------------------------------- */
      this.doctoresService.mostrarDoctoresNormal(localStorage.getItem('token'),"CodVendedor", content[0].CODN_DOC).subscribe((resp) => {
        this.talonarioDocotor = content[0].Abreviatura;

      });

      var preciosSelect :any[] = [];

       /* -------------------------------------------------------------------------- */
       /*                             DETALLE DE LA ORDEN                            */
       /* -------------------------------------------------------------------------- */

      
      
        var content = JSON.parse(content[0].DET_ORD);
        content.forEach((currentValue, index) => {
        
          preciosSelect.push({
           
            "precio" :  currentValue.precio1,


            },{

              "precio" :currentValue.precio2,


          },{

              "precio" :  currentValue.precio3,


          },{

            "precio" :currentValue.precio4,


          });

          if(currentValue.tipo=="LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)"){

            this.detalleOrden.push({
  
              id: currentValue.id,
              producto: currentValue.producto,
              codigo : currentValue.codigo,
              valor: currentValue.valor,
              pieza:  currentValue.pieza,
              agregado: " ",
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto:  currentValue.impuesto,
              incluidoIva:  currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo:currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos:[],
              videosBase:[],
              documentos:[],
              documentosBase:[],
              imagenesSubidas: currentValue.imagenesSubidas ?  JSON.parse(JSON.stringify(currentValue.imagenesSubidas)) : [],
              documentosSubidos: currentValue.documentosSubidos ?  JSON.parse(JSON.stringify(currentValue.documentosSubidos)) : [],
              videosSubidos : currentValue.videosSubido ? JSON.parse(JSON.stringify(currentValue.videosSubidos)) : [],
              tipoSubida: "LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)"
              
            });   
                   
        }

        if (currentValue.tipo == 'ECOGRAFIA'  ||  currentValue.tipo == 'ECOGRAFIAS ESPECIALES') {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'ECOGRAFIA',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }

        if (
          currentValue.tipo == 'TOMOGRAFIA 3D' ||
          currentValue.tipo == 'TOMOGRAFIA 3D (MATRIZ)'
        ) {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'TOMOGRAFIA 3D',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }

        if (
          currentValue.codigo == 'PERIAP-PLUS' ||
          currentValue.codigo == 'PERIAPICAL' ||
          currentValue.codigo == 'SERIE 002' ||
          currentValue.codigo == 'PERIAP-PLUS-FISCIO'
        ) {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'PERIAPICAL',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }

        if (
          currentValue.codigo == 'PANO 001' ||
          currentValue.codigo == 'PANO 002' ||
          currentValue.codigo == 'A.T.M.' ||
          currentValue.codigo == 'PANO PLUS' ||
          currentValue.codigo == 'LATE 001' ||
          currentValue.codigo == 'RX-CARPAL' ||
           currentValue.codigo=="SENOS 001" ||
           currentValue.codigo=="ANTEROPOSTERIOR"
        ) {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'PANORAMICA',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }

        if (currentValue.tipo == 'BAZAR' || currentValue.tipo == 'FARMACIA') {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'BAZAR',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }

        if (currentValue.tipo == 'INYECTOLOGIA') {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'INYECTOLOGIA',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }

        if (currentValue.tipo == 'SUEROTERAPIA') {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'SUEROTERAPIA',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }

        if (currentValue.tipo == 'RADIOGRAFIAS CORPORAL') {
          this.detalleOrden.push({
            id: currentValue.id,
            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'SUEROTERAPIA',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }
         

        });
       
        this.detalleOrden.forEach((orden, i) => {
          orden.imagenesSubidas.forEach(imagen => {
            if(imagen.guardadoServidor){
              imagen.imagen = this.resolverUrlMultimedia(imagen.imagen);
            }else{
              //obtiene del drive y guarda en el servidor
              this.getUrL(imagen); 
            }
            // Llama a getUrL para cada imagen
          });
        });
       
       this.spinnerBoolean = false;
    });

  }


  
  /* -------------------------------------------------------------------------- */
  /*                                 PRECIO ITEM                                */
  /* -------------------------------------------------------------------------- */
  precioItem(codigo,precio1:any, precio2, precio3, precio4, derivado, tipo, precioLab, preciosDerivados){

    if(precioLab!="" && tipo=="LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)"){

      if(precioLab=="A"){

        precio1 = precio1;
       
      }

      if(precioLab=="B"){

        precio1 =  precio2 == ""  ? precio1 : precio2;

      
      }

      if(precioLab=="C"){

        precio1 = precio3 == ""  ? precio1 :precio3 ;
      
      }
      if(precioLab=="D"){

       precio1 = precio4  == ""  ? precio1 : precio4 ;
       
      }


  }else{

  
    if(precio1==""){
      
      precio1 = this.talonarioDocotor;
  
      
    }

  }

  var precioDerivado = "";
  
  if(derivado=="1"){

    var content = JSON.parse(preciosDerivados);
    $.each(content, function(id, name) {


      precioDerivado = name.precio;


  });
      
  }
  

 
  if(Number(precio2)<Number(precioDerivado)){
      
      precio2 = "";
  }
  
  if(Number(precio3)<Number(precioDerivado)){
      
      precio3 = "";
  }
  
    if(Number(precio4)<Number(precioDerivado)){
      
      precio4 = "";
  }


  if(this.metodosPagos!="EFECTIVO" && this.metodosPagos!=""){
                
   
    precio1 = (precio1*1.06);
    precio1 = parseFloat(precio1).toFixed(2)

    precio2 = (precio2 == "" ? 0 : precio2 *1.06);
    precio2 = parseFloat(precio2).toFixed(2)

    precio3 = (precio3 == "" ? 0 : precio3*1.06);
    precio3 = parseFloat(precio3).toFixed(2)

    precio4 = (precio4 == "" ? 0 : precio4 *1.06);
    precio4 = parseFloat(precio4).toFixed(2)
  
  
  }
   


    return precio1+","+precio2+","+precio3+","+precio4;
  }


  /* -------------------------------------------------------------------------- */
  /*                         SELECCIONAR IMAGEN DROPZONE                        */
  /* -------------------------------------------------------------------------- */
  onSelect(event: any, files, filesBase) {

    files.push(...event.addedFiles);
  }
  


  /* -------------------------------------------------------------------------- */
  /*                           REMOVER IMAGEN DROPZONE                          */
  /* -------------------------------------------------------------------------- */
  onRemove(event: any,files, filesBase) {
    files.splice(files.indexOf(event), 1);

 
  }	


  /* -------------------------------------------------------------------------- */
  /*                               SUBIR IMAGENES                               */
  /* -------------------------------------------------------------------------- */
 
  /* -------------------------------------------------------------------------- */
  /*                               SUBIR IMAGENES                               */
  /* -------------------------------------------------------------------------- */
  async subirImagenes(){
    this.cargando = "Guardando informe corporal, por favor espere....";
    this.spinnerBoolean = true;

    this.ordenesService.generarInforme(
      this.idOrden,
      this.informeHtml,
      localStorage.getItem('token')
    ).subscribe({
      next: () => {
        this.spinnerBoolean = false;
        this.toastr.success("Informe corporal guardado correctamente", 'Atención', {
          timeOut: 7000,
          closeButton: true,
          progressBar: true
        });
        this.router.navigateByUrl('sistema/corporales');
      },
      error: (error) => {
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message || "No se pudo guardar el informe corporal",
          'Atención',
          {
            timeOut: 7000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    });
  }


  /* -------------------------------------------------------------------------- */
  /*                           VOLVER A LISTA ORDENES                           */
  /* -------------------------------------------------------------------------- */
  volverAtras(){

    this.router.navigateByUrl('sistema/inicio');

  }


  /* -------------------------------------------------------------------------- */
  /*                                SUBIR VIDEOS                                */
  /* -------------------------------------------------------------------------- */
  subirDocumentos(event, documentos, documentosBase){

    if(event.target.files[0]["type"] == "image/jpeg" || event.target.files[0]["type"] == "image/png"){

      this.toastr.error('El formado no es de tipo documento', 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      event.target.value = "";

      return;
    }

    documentos.push(event.target.files[0]);
  
    for(var i = 0; i < documentos.length; i++) {

      const file = documentos[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {

        if(documentos.length <=1){

          documentosBase.push({
  
            "documentos" : reader.result
          })
        }

        for(var j = 0; j < documentosBase.length; j++) {

            if(reader.result !== documentosBase[j].documentos){
              documentosBase.push({
  
                "documentos" : reader.result
              })
  
            }
          

       

        
        }
     
        
         
      };

    }

    
  }
  

  /* -------------------------------------------------------------------------- */
  /*                              SUBIR DOCUMENTOS                              */
  /* -------------------------------------------------------------------------- */
  subirVideos(event, videos, videosBase){
    videos.push(event.target.files[0]);
    for(var i = 0; i < videos.length; i++) {

      const file = videos[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(!videosBase.includes(reader.result)){
          videosBase.push({

            "videos" : reader.result
          })
        }        
      };

    }
  
  }


  /* -------------------------------------------------------------------------- */
  /*                                ORDEN FISICA                                */
  /* -------------------------------------------------------------------------- */
  ordenFisica(event){

    const file =  event.target.files[0]
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
    

    this.txtOrdenFisica = reader.result as string;
      
    };        
  }


  /* -------------------------------------------------------------------------- */
  /*                          ELIMINAR ITEMS DOCUMENOS                          */
  /* -------------------------------------------------------------------------- */
  borrarItem(array, index){

    array.splice(index, 1);

  }
  
  imgBase(){

    this.detalleOrden.map((item) => {
     
      item.imagenes.map((item1) => {
        const file = item1;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {


         
         
         await item.imagenesBase.push({
  
              "imagenes" : reader.result
            })
               
        };
  
      });
    });
   
    
  }

  getUrL(img: any) {
    this.ordenesService.getImageServer(img.imagen, localStorage.getItem('token'))
      .subscribe((resp) => {
        img.imagen = resp; // Actualiza la propiedad 'url' del objeto de imagen
        img.guardadoServidor = true;
      });
  }

  private resolverUrlMultimedia(referencia: string): string {
    if (/^https?:\/\//i.test(referencia || '')) {
      return referencia;
    }

    return this.baseSistema + "/radiografia/vistas/img/multimedia/" + referencia;
  }

  verContenidoVideo(objetoVideo, event:MouseEvent){
    event.preventDefault();
    if(objetoVideo.guardadoServidor){
      window.open(this.resolverUrlMultimedia(objetoVideo.videos),"_blank");
    }else{
        window.open(`http://drive.google.com/uc?export=view&id=${objetoVideo.videos}`,"_blank")
    }
  }

  verContenidoDocumentos(objetoDocumento, event:MouseEvent){
    event.preventDefault();
    if(objetoDocumento.guardadoServidor){
      window.open(this.resolverUrlMultimedia(objetoDocumento.documentos),"_blank");
    }else{
        window.open(`http://drive.google.com/uc?export=view&id=${objetoDocumento.documentos}`,"_blank")
    }
  }


 
async startRecording() {
  try {
    this.audioChunks = [];
    this.audioFile = null;
    this.audioUrl = '';

    this.audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });

    this.mediaRecorder = new MediaRecorder(this.audioStream);
    this.isRecording = true;

    this.mediaRecorder.ondataavailable = (event: BlobEvent) => {
      if (event.data && event.data.size > 0) this.audioChunks.push(event.data);
    };

    this.mediaRecorder.onstop = () => {
      const blob = new Blob(this.audioChunks, { type: this.mediaRecorder?.mimeType || 'audio/webm' });
      this.audioMime = blob.type;

      // URL para reproducir
const url = URL.createObjectURL(blob);
this.audioUrl = url;
this.safeAudioUrl = this.sanitizer.bypassSecurityTrustUrl(url);

      // Convertir a File para subirlo como archivo
      const ext = this.audioMime.includes('webm') ? 'webm'
                : this.audioMime.includes('ogg') ? 'ogg'
                : 'mp3';

      this.audioFile = new File([blob], `informe-audio.${ext}`, { type: this.audioMime });

      // Cerrar el micrófono
      this.audioStream?.getTracks().forEach(t => t.stop());
      this.audioStream = null;

      this.isRecording = false;
    };

    this.mediaRecorder.start();

  } catch (err) {
    this.isRecording = false;
    // aquí puedes usar toastr
    // this.toastr.error('No se pudo acceder al micrófono');
    console.error(err);
  }
}

stopRecording() {
  if (this.mediaRecorder && this.isRecording) {
    this.mediaRecorder.stop();
  }
}

clearRecording() {
  if (this.audioUrl) URL.revokeObjectURL(this.audioUrl);
  this.audioUrl = '';
  this.safeAudioUrl = null;
  this.audioFile = null;
  this.audioMime = '';
  this.audioChunks = [];
}


startDictation() {
  const SpeechRecognition =
    (window as any).SpeechRecognition ||
    (window as any).webkitSpeechRecognition;

  if (!SpeechRecognition) {
    alert('Tu navegador no soporta dictado de voz');
    return;
  }

  this.recognition = new SpeechRecognition();
  this.recognition.lang = 'es-ES';
  this.recognition.interimResults = true;   // <- clave
  this.recognition.continuous = true;       // <- clave
  this.zone.run(() => {
  this.dictando = true;
});
  
this.recognition.onresult = (event: any) => {
  let finalText = '';
  let interimText = '';

  for (let i = event.resultIndex; i < event.results.length; i++) {
    const res = event.results[i];
    const transcript = res[0].transcript;

    if (res.isFinal) {
      finalText += transcript + ' ';
    } else {
      interimText += transcript + ' ';
    }
  }
this.zone.run(() => {
  this.textoTemporal = this.normalizarPuntuacion(interimText.trim());
  if (finalText.trim()) {
    const limpio = this.normalizarPuntuacion(finalText);
    this.informeHtml = (this.informeHtml + ' ' + limpio).trim();
    this.textoTemporal = '';
  }
});
};
  console.log(this.dictando);
console.log(this.textoTemporal);
 this.recognition.onerror = () => {
  this.zone.run(() => this.stopDictation());
};

this.recognition.onend = () => {
  this.zone.run(() => {
    if (this.dictando) this.recognition.start();
  });
};
  this.recognition.start();
}

stopDictation() {
  this.dictando = false;
  this.textoTemporal = '';

  try {
    this.recognition?.stop();
  } catch {}
}

  private normalizarPuntuacion(texto: string): string {
  return texto
    .replace(/\bcoma\b/gi, ',')
    .replace(/\bpunto\b/gi, '.')
    .replace(/\bdos puntos\b/gi, ':')
    .replace(/\bpunto y coma\b/gi, ';')
    .replace(/\bnueva línea\b/gi, '\n')
    .replace(/\bsigno de interrogación\b/gi, '?')
    .replace(/\bsigno de exclamación\b/gi, '!');
}
}
